import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { AURORA_MYSQL } from "../../Constants"

function ZdqAuroraMySqlConnectorStatus() {
    return <ZdqConnectorStatus vendor={AURORA_MYSQL}></ZdqConnectorStatus>
}

export default ZdqAuroraMySqlConnectorStatus